export class LogMessage {
    ID: number;
    Severity: string;
    Message: string;
    MessageBrief: string;
    ValidationErrors: string;
    StackTrace: string;
    StackTraceBrief: string;
    MessageDate: Date;
    RequestID: number;
    CustomerNumber?: string;
}

export default LogMessage;